import React from 'react';
import { Navigate } from 'react-router-dom';

function PrivateRoute({ children, user, requiredType }) {
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredType && user.userType !== requiredType) {
    return <Navigate to={`/${user.userType}/dashboard`} replace />;
  }

  return children;
}

export default PrivateRoute;
